var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.customFields && _vm.customFields.length
    ? _c(
        "div",
        { staticClass: "profile-ud-list sip-kv-grid" },
        [
          _vm._l(_vm.customFields, function (field) {
            return [
              _c("view-label", {
                key: field.id,
                attrs: {
                  label: field.name,
                  value: field["value"],
                  type: field.type == "datepicker_input" ? "date" : "string",
                  "col-span": _vm.getCustomFieldColSpan(field),
                },
              }),
            ]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }